import React, { useContext } from 'react';
import { I18n } from 'aws-amplify';
import { Button } from '@material-ui/core';
import { GraySmall } from 'src/theme/colors';
import BaseTypography from 'src/components/Text/BaseTypography';
import { FlagsContext } from 'src/context';

interface AuthLinkActionButtonProps {
  className: string;
  onClick: () => void;
  linkText: string;
}

export const AuthLinkActionButton: React.FC<AuthLinkActionButtonProps> = ({
  className,
  onClick,
  linkText,
}) => {
  const { GoogleLoginForClients } = useContext(FlagsContext);
  return (
    <div
      className={className}
      style={{
        justifyContent: GoogleLoginForClients ? 'center' : 'space-between',
      }}
    >
      <Button onClick={onClick}>
        <BaseTypography
          style={{
            color: GraySmall,
            cursor: 'pointer',
          }}
        >
          {I18n.get(linkText)}
        </BaseTypography>
      </Button>
    </div>
  );
};
